import React from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'
import Img from 'gatsby-image'

export const ImageWrap = styled.div`
    ${(props) =>
        props.size &&
        css`
            max-width: ${props.size}px;
            margin-left: auto;
            margin-right: auto;
        `}
`
const DesktopImage = styled.div`
    ${media('<desktop')} {
        display: none;
    }
`

const MobileImage = styled.div`
    ${media('>=desktop')} {
        display: none;
    }
`

const ResponsiveImage: React.FC<{
    image: object
}> = ({ image }) => {
    return (
        <>
            {image && image.desktopImage && (
                <ImageWrap size={image.maxWidth}>
                    {image.mobileImage ? (
                        <>
                            <DesktopImage>
                                <Img fluid={image.desktopImage.fluid} />
                            </DesktopImage>
                            <MobileImage>
                                <Img fluid={image.mobileImage.fluid} />
                            </MobileImage>
                        </>
                    ) : (
                        <Img fluid={image.desktopImage.fluid} />
                    )}
                </ImageWrap>
            )}
        </>
    )
}

export default ResponsiveImage
